import React from 'react';
import { useDispatch } from 'react-redux';

import MobileNavigation from '../mobile-navigation/MobileNavigation';
import UserMenu from '../user-menu/UserMenu';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { toggleSidebar } from '../../../redux/sidebar/sidebarReducer';

import scss from './MobileMenu.module.scss';
import SupportSection from '../support-section/SupportSection';

function MobileMenu() {
  const dispatch = useDispatch();

  const handleCloseMenu = () => {
    dispatch(toggleSidebar());
  };
  return (
    <div className={scss.wrapper}>
      <div className={scss.closeWrapper}>
        <Icon icon={ICONS.Cross} className={scss.closeIcon} onClick={handleCloseMenu} />
      </div>

      <MobileNavigation onCloseMenu={handleCloseMenu} />

      <UserMenu />

      <SupportSection />
    </div>
  );
}

export default MobileMenu;
